import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {MainDataService} from "../../../shared/services/main-data.service";
import {AppDataService} from "../../../shared/services/app-data.service";

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  public tenant = new Subject();
  public header = new Subject();

  constructor(private mainDataService: MainDataService,
              private appDataService: AppDataService) {
  }

  setTenant(tenantId: any) {
    this.tenant.next(tenantId);
  }
  getTenant() {
    return this.tenant;
  }

  setHeader(tenantId: any) {
    this.header.next(tenantId);
  }
  getHeader() {
    return this.header;
  }
  async getAppConfigurationData(): Promise<any> {
    let appCache = localStorage.getItem('appData_cache')

    if (!appCache || appCache == '') {
      const initialDataPromise = this.mainDataService.getInitialData().toPromise();
      const configurationPromise = this.mainDataService.getConfigurationData().toPromise();
      const tenantsPromise = this.mainDataService.getAllCountryTenants().toPromise();
      const categoriesPromise = this.mainDataService.getAllCategories().toPromise();
      const tenantShowRoomConfig = this.mainDataService.getTenantShowRoomConfiguration().toPromise();
      let res: any = await Promise.all([
        initialDataPromise,
        configurationPromise,
        tenantsPromise,
        categoriesPromise,
        tenantShowRoomConfig
      ]);
      this.appDataService.initialData = res[0].data
      this.appDataService.configuration = res[1].data
      this.appDataService.tenants = res[2].data
      this.appDataService.categories = res[3].data
      this.appDataService.tenantShowRoomConfig = res[4].data

      const appDataCache = {
        initialData: res[0].data,
        configuration: res[1].data,
        tenants: res[2].data,
        categories: res[3].data,
        showRoomConfiguration: res[4].data,
      }

      localStorage.setItem('appData_cache', JSON.stringify(appDataCache))
    } else {
      let appDataCache: any = localStorage.getItem('appData_cache') ?? ''
      if (!appDataCache || appDataCache === '') {
        localStorage.removeItem('appData_cache')
        await this.getAppConfigurationData()
      } else {
        appDataCache = JSON.parse(appDataCache)
        this.appDataService.initialData = appDataCache.initialData
        this.appDataService.configuration = appDataCache.configuration
        this.appDataService.tenants = appDataCache.tenants
        this.appDataService.categories = appDataCache.categories
        this.appDataService.tenantShowRoomConfig = appDataCache.showRoomConfiguration
      }
    }


  }

}
